import GalleryArrow from './GalleryArrow';

export default GalleryArrow;
